<form snDrawer [formGroup]="form" (ngSubmit)="submitForm()">
  <sn-drawer-header [title]="'common.filters' | t">
    <button mat-icon-button snDrawerClose snDrawerNavButton>
      <mat-icon>close</mat-icon>
    </button>
    <sn-drawer-header-actions>
      <button mat-flat-button color="success" class="applyBtn">{{ 'common.apply' | t }}</button>
    </sn-drawer-header-actions>
  </sn-drawer-header>

  <sn-drawer-content indented>
    <sn-form [form]="form" [fields]="formFields" [(model)]="formModel"></sn-form>
    <button mat-button color="danger" (click)="resetForm()">{{ 'common.clearAll' | t }}</button>
  </sn-drawer-content>
</form>
